import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failurelistFAQ, successlistFAQ } from "./ListFAQSlice";

const ListFAQApi = () => {
    return api.get("/api/faq/");
};

export function* ListFAQCall() {
    try {
        const response: AxiosResponse = yield call(ListFAQApi);
        yield put(successlistFAQ(response.data));
    } catch (error) {
        yield put(failurelistFAQ(error));
    }
}
